import styled from "styled-components";

export const RouteNotFoundContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  width: 100%;
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const MessageContainer = styled.div`
  text-align: center;
  padding: 24px;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  max-width: 500px;
  width: 100%;
`;

export const ErrorCode = styled.h1`
  font-size: 64px;
  font-weight: 900;
  color: #FFF;
  margin: 0 0 20px 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  line-height: 1;
`;

export const ErrorMessage = styled.p`
  font-size: 16px;
  color: #FFF;
  margin: 0 0 40px 0;
  font-weight: 500;
  line-height: 1.4;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const MainGradientBGContainer = styled.div`
  height: 100vh;
  position: fixed;
  width: 100vw;
  z-index: -500;
`;